import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { EapStudyTeamTeamViewModalComponent } from './eap-study-team-team-view-modal/eap-study-team-team-view-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eap-study-team-team',
  templateUrl: './eap-study-team-team.component.html',
  styleUrls: ['./eap-study-team-team.component.scss']
})
export class EapStudyTeamTeamComponent implements OnInit {

  columnDefs;
  tempoperations;
  operations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  UserRoleList: any[];
  ApplicationID: string;
  studyTeamAdaceSearch: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
  constructor(
    private router: Router, 
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.permission = "";
    if (this.commonService.getPagePermission("EAP02") != null && this.commonService.getPagePermission("EAP02") != undefined) {
      this.permission = this.commonService.getPagePermission("EAP02").toLowerCase();
    }
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      //this.modalService.open(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Please save the first form of the application, before navigating to the other forms." } } });
      return false;
    }
    debugger;
    this.userType = this.userService.getUserType();
    this.studyTeamAdaceSearch = new UntypedFormGroup({
      FirstNAME: new UntypedFormControl(null),
      OrganizationName: new UntypedFormControl(null),
      UserRole: new UntypedFormControl(null),
      Occupation: new UntypedFormControl(null),
      EmailID: new UntypedFormControl(null),
      PhoneNumber: new UntypedFormControl(null),
    });

   

    this.setMasterData();
    this.columnDefs = [
      {
        "headerName": "First Name",
        "field": "FirstNAME",
        "sort": "asc"
      },
      {
        "headerName": "Role",
        "field": "OrganizationName"
      },
      {
        "headerName": "Occupation",
        "field": "Occupation"
      },
      {
        "headerName": "Email ID",
        "field": "EmailID"
      },
      {
        "headerName": "Phone No",
        "field": "PhoneNumber"
      }
    ];
      this.tempoperations = [];

    if (this.permission == "edit") {
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
      this.tempoperations.push({
        "name": "Delete",
        "id": "delete"
      });
    }
   if (this.permission == "new") {
      this.tempoperations.push({
        "name": "Add",
        "id": "add"
      });
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
     this.tempoperations.push({
       "name": "Delete",
       "id": "delete"
     });
    }

   this.advanceSearch=
    {
      "fields": [
        {
          "label": "First Name",
          "field": "FirstName",
          "type": "text"
        },
        {
          "label": "Organisation Name",
          "field": "OrganizationName",
          "type": "text"
        },
        {
          "label": "User Role",
          "field": "UserRole",
          "type": "dropdown",
          "options": this.UserRoleList,
        },
        {
          "label": "Occupation",
          "field": "Occupation",
          "type": "text"
        },
        {
          "label": "Email",
          "field": "EmailID",
          "type": "text"
        },
        {
          "label": "Phone Number",
          "field": "PhoneNumber",
          "type": "text"
        }
      ]
   }

    this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  
    this.setSummary();
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService, this.datashareService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    // this.modalService.show(EapStudyTeamTeamViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-vlg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'View',
    //     content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    //   }
    // });
  }

  add_open_form(){
    this['self'].router.navigate(['/home/ist/applications/application-ext/:1/study_team_team_request/study_team_team_request/:1'],{skipLocationChange:true})
  }

  add(service, datashareService1) {
    // var emptyList = [];
    // datashareService1.setIstMemberOrgList(emptyList);
    // let modalRef = this['self'].modalService.show(EapStudyTeamTeamViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-vlg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Add',
    //     content: { id: "", ApplicationID: this.ApplicationID }
    //   }
    // });
    // modalRef.content.action.subscribe(result => {
    //   debugger;
    //   this['self'].setSummary();
    // })
  }

  edit() {
    // let modalRef = this['self'].modalService.show(EapStudyTeamTeamViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-vlg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Edit',
    //     content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    //   }
    // });
    // modalRef.content.action.subscribe(result => {
    //   this['self'].setSummary();
    // })
  }

  delete(summaryService,dataservice, toastrService) {
    // let id = this['self'].selectedRow['ID'];
    // if (this['self'].selectedRow["CREATED_BY"] != "Admin") {
    //   this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
    //   this["self"].modalRef.content.action.subscribe(result => {
    //     summaryService.DeleteRecord('api/EAPStudyTeam/Delete?RecordID=' + id).subscribe(summary => {
    //       if (summary["Status"] == 0) {
    //         toastrService.success("Selected Record(s) has been Deleted");
    //         this['self'].setSummary();
    //       }
    //       else {
    //         toastrService.error("Operation Conflict:Record can't be deleted.");
    //       }
    //     });
    //   });
    // }
    // else {
    //    this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Alert', content: { heading: '', description: "Default Record can't be Deleted." } } });

    // }
   
  }

  add_org(){
    // let modalRef = this['self'].modalService.show(EapStudyTeamTeamViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-vlg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Add',
    //     content: { id: '', ApplicationID: this.ApplicationID }
    //   }
    // });
   
  }
  getSearchData(formData) {
    this.summaryService.fetchSearchData("api/EAPStudyTeam/GetSummarySearchData", formData).subscribe(summary => {
      this.rowData = summary
    });
  }
  setSummary() {
    this.SearchClear();
    if (this.ApplicationID != "" && this.ApplicationID != undefined) {
      this.summaryService.getSummaryData("api/EAPStudyTeam/GetSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
        this.rowData = summary
      });
    }
    else {
      this.rowData = [];
    }
   
  }
  setMasterData() {
    this.summaryService.masterData("api/EAPStudyTeam/GetMasterData?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      debugger;
      this.UserRoleList = summary["MasterData2"];
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.studyTeamAdaceSearch.reset();
  //  this.setSummary();
  }
  AdvanceSearch() {
    var formData = this.studyTeamAdaceSearch.value;
    debugger;
    formData["ApplicationID"] = this.ApplicationID;
    this.getSearchData(formData);
  }

  onAdvanceSearchOperation(searchFiletrs) {
    
  }
}
